<script>
import { Component, Vue, Prop, Emit } from "vue-property-decorator";
import * as utils from "src/store/utils";
import { getTable } from "./config";
@Component({
  components: {}
})
export default class orderPrint extends Vue {
  get tableInfo() {
    return getTable(this.info, this.brand);
  }
  @Prop({
    type: Object,
    default: () => ({})
  })
  info;

  @Prop({
    type: String,
    default: '1'
  })
  brand;

  render(h) {
    return (
      <div class="order-manual__print">
        <multiline-print
          {...{
            props: {
              info: this.tableInfo
            }
          }}
        ></multiline-print>
      </div>
    );
  }
}
</script>

<style lang="scss">
.order-manual__print {
  font-size: 3mm;
  box-sizing: border-box;
  .order-manual__box-main {
    padding: 1px;
    height: 100%;
    p {
      height: 33%;
    }
  }
  .order-manual__box__left {
    padding: 1px;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .order-manual__box-content {
    display: flex;
    padding: 1px;
    height: 100%;
    .order-manual-content {
      width: 50%;
      // display: flex;
      text-align: left;
      .order-manual-content__left {
        display: flex;
        width: 100%;
        font-size: 2.5mm;
        .order-manual-content__img {
          &.isN {
            width: 16mm;
            height: 16mm;
            margin-bottom: 6mm;
          }
          padding: 1px;
          width: 20mm;
          height: 20mm;
          padding-right: 3mm;
        }
      }
      .order-manual-content__right {
        width: 100%;
        padding-right: 3mm;
        p {
          width: 100%;
          height: 8mm;
        }
      }
    }
  }
}
</style>
